// @ts-check

import { useArrayReduce } from '@vueuse/core'
import { computed } from 'vue'

/**
 * @param {EntryItemResource[]} items
 */
export const useEntryItems = (items) => {
  const itemsTotals = computed(() => {
    const totalWithVat = useArrayReduce(
      items,
      (total, item) => total + item.price,
      0
    )
    const totalWithoutVat = useArrayReduce(
      items,
      (total, item) => total + item.price / (1 + item.vat / 100),
      0
    )
    const totalVatAmount = useArrayReduce(
      items,
      (total, item) => total + item.price - item.price / (1 + item.vat / 100),
      0
    )

    return {
      total_with_vat: totalWithVat.value || 0,
      total_without_vat: totalWithoutVat.value || 0,
      total_vat_amount: totalVatAmount.value || 0
    }
  })

  return {
    itemsTotals
  }
}

export default useEntryItems
